import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { ProductType } from '@travelity/api/generated';
import MainLayout from '../layouts/main-layout';
import AuthenticationGuard from './authentication-guard';
import UserProfile from '../views/user-profile';
import Availability from '../views/availability';
import AddProduct from '../views/add-product';
import Products from '../views/products';
import SelectType from '../views/select-type';
import Error404 from '../views/error-404';
import OrderPage from '../views/order-page';
import Orders from '../views/orders';
import { OTAs } from '../views/otas';
import Events from '../views/events';
import AcceptTeamInvitation from '../views/accept-team-invitation';
import Teams from '../views/teams';
import Bookings from '../views/bookings';
import TeamPage from '../views/team-page';
import { ProductVariants } from '../views/product-variants';
import AddPackage from '../views/add-package';
import { Widget } from '../views/widget';
import { Ameriabank, Flitt } from '../views/payments';

const Dashboard = lazy(() => import('../views/dashboard/dashboard'));

const MainRoutes = {
    path: '/',
    element: <AuthenticationGuard component={MainLayout} />,
    children: [
        {
            path: '/',
            element: <Navigate to="/events" />,
        },
        {
            path: '/dashboard',
            element: (
                <Suspense fallback={<div>Loading dashboard...</div>}>
                    <Dashboard />
                </Suspense>
            ),
        },
        {
            path: '/availability',
            element: <Availability />,
        },
        {
            path: '/products/add',
            element: <SelectType />,
        },
        {
            path: `/products/add/${ProductType.DYNAMIC_PACKAGE}`,
            element: <AddPackage />,
        },
        {
            path: '/products/add/:productType',
            element: <AddProduct />,
        },
        {
            path: '/products/:productId',
            element: <Products />,
        },
        {
            path: '/products',
            element: <Products />,
        },
        {
            path: '/events/:eventId/:tabName?/:mode?',
            element: <Events />,
        },
        {
            path: '/events',
            element: <Events />,
        },
        {
            path: '/events/:eventId/booking/:bookingId?/:tabName?/:mode?',
            element: <Events />,
        },
        {
            path: '/teams',
            element: <Teams />,
        },
        {
            path: '/teams/:teamId/member/:memberId/:tabName?/:mode?',
            element: <Teams />,
        },
        {
            path: '/team/:teamId/member?/:memberId?/:tabName?/:mode?',
            element: <TeamPage />,
        },
        {
            path: '/orders',
            element: <Orders />,
        },
        {
            path: '/widget',
            element: <Widget />,
        },
        {
            path: '/otas',
            element: <OTAs />,
        },
        {
            path: '/payments/ameriabank',
            element: <Ameriabank />,
        },
        {
            path: '/payments/flitt',
            element: <Flitt />,
        },
        {
            path: '/otas/:otaId',
            element: <ProductVariants />,
        },
        {
            path: '/orders/:orderId',
            element: <Orders />,
        },
        {
            path: '/order/:orderId/booking/:bookingId/:tabName?/:mode?',
            element: <OrderPage />,
        },
        {
            path: '/order/:orderId/:preview?/:tabName?/:mode?',
            element: <OrderPage />,
        },
        {
            path: '/bookings/:bookingId?/:tabName?/:mode?',
            element: <Bookings />,
        },
        {
            path: '/me',
            element: <UserProfile />,
        },
        {
            path: '/me/*',
            element: <UserProfile />,
        },
        {
            path: '/accept_invitation/:teamId/:key',
            element: <AcceptTeamInvitation />,
        },
        {
            path: '*',
            element: <Error404 />,
        },
    ],
};

export default MainRoutes;
